import { Box } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/DraftErrorsCard/DraftErrorsCard.styles';
import { DraftError } from 'types/draftError';

interface DraftValidationErrorsCardSectionProps {
  errors: DraftError[] | undefined;
  title: string;
}

const DraftErrorsCardSection = ({ errors, title }: DraftValidationErrorsCardSectionProps) => {
  const classes = useStyles();

  if (!errors?.length) {
    return null;
  }

  return (
    <Box>
      {title}
      <ul className={classes.ul}>
        {errors.map((error) => (
          <li className={classes.li}>{error.reason}</li>
        ))}
      </ul>
    </Box>
  );
};

export default DraftErrorsCardSection;
